/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListCMAResponseItemDto } from './ListCMAResponseItemDto';
import {
    ListCMAResponseItemDtoFromJSON,
    ListCMAResponseItemDtoFromJSONTyped,
    ListCMAResponseItemDtoToJSON,
    ListCMAResponseItemDtoToJSONTyped,
} from './ListCMAResponseItemDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListCMAResponseDto
 */
export interface ListCMAResponseDto {
    /**
     * 
     * @type {Array<ListCMAResponseItemDto>}
     * @memberof ListCMAResponseDto
     */
    items: Array<ListCMAResponseItemDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListCMAResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListCMAResponseDto interface.
 */
export function instanceOfListCMAResponseDto(value: object): value is ListCMAResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListCMAResponseDtoFromJSON(json: any): ListCMAResponseDto {
    return ListCMAResponseDtoFromJSONTyped(json, false);
}

export function ListCMAResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCMAResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ListCMAResponseItemDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListCMAResponseDtoToJSON(json: any): ListCMAResponseDto {
    return ListCMAResponseDtoToJSONTyped(json, false);
}

export function ListCMAResponseDtoToJSONTyped(value?: ListCMAResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ListCMAResponseItemDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

